// src/components/tenant/TenantSidebar.jsx
import React from 'react';
import { Drawer, List, ListItemButton, ListItemIcon, ListItemText, Box, Typography, Divider } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import PaymentsIcon from '@mui/icons-material/Payment';
import BuildIcon from '@mui/icons-material/Build';
import CampaignIcon from '@mui/icons-material/Campaign';
import DescriptionIcon from '@mui/icons-material/Description';
import ContactsIcon from '@mui/icons-material/Contacts';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import StorefrontIcon from '@mui/icons-material/Storefront';
import { useNavigate, useLocation } from 'react-router-dom';

const menuItems = [
  { text: 'Home', icon: <HomeIcon />, path: '/tenant' },
  { text: 'Payments', icon: <PaymentsIcon />, path: '/tenant/payments' },
  { text: 'Requests', icon: <BuildIcon />, path: '/tenant/requests' },
  { text: 'Announcements', icon: <CampaignIcon />, path: '/tenant/announcements' },
  { text: 'Documents', icon: <DescriptionIcon />, path: '/tenant/documents' },
  { text: 'Contacts', icon: <ContactsIcon />, path: '/tenant/contacts' },
  { text: 'Calendar', icon: <CalendarMonthIcon />, path: '/tenant/calendar' },

];

export default function TenantSidebar() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Drawer variant="permanent" sx={{ width: 250, flexShrink: 0, '& .MuiDrawer-paper': { width: 250, boxSizing: 'border-box', borderRight: 0 } }}>
      <Box p={2}>
        <img src="https://i.ibb.co/s2dBvDt/elevate.png" alt="Logo" style={{ width: 400,  position: 'relative', display: 'flex', alignItems: 'center' }} />
      </Box>

      <Divider />

      <List>
        {menuItems.map((item, i) =>
          item.children ? (
            <Box key={i}>
              <ListItemButton>
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText primary={item.text} />
              </ListItemButton>
              {item.children.map((sub, j) => (
                <ListItemButton
                  key={j}
                  sx={{ pl: 6 }}
                  selected={location.pathname === sub.path}
                  onClick={() => navigate(sub.path)}
                >
                  <ListItemText primary={sub.text} />
                </ListItemButton>
              ))}
            </Box>
          ) : (
            <ListItemButton
              key={i}
              selected={location.pathname === item.path}
              onClick={() => navigate(item.path)}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          )
        )}
      </List>
    </Drawer>
  );
}